export default function reverseString(source) {
    return Array.from(source).reverse().join('');
}
//# sourceMappingURL=reverseString.js.map